import { Box, Dialog, Typography, useTheme } from "@mui/material"
import WizardStep from "./Wizard/WizardStep";

type Props = {
    open: boolean,
    title: string,
    message: string,
    onConfirm?: () => void,
    onCancel: () => void,
    onOkay?: () => void
}

const ConfirmationDialog = ({ open, onConfirm, onOkay, onCancel, title, message }: Props) => {
    const theme = useTheme();

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick") return;

        onCancel();
    };

    return (
        <Dialog PaperProps={{
            sx: { minHeight: 200, border: `1px solid ${theme.palette.divider}` }
        }} onClose={handleClose} open={open} fullWidth maxWidth={'sm'} disableEscapeKeyDown>
            <Box sx={{ padding: 1 }}>
                <WizardStep onCancel={onCancel} onOkay={onOkay} onConfirm={onConfirm}>
                    {title && <Typography variant="h6">{title}</Typography>}
                    <Typography variant='subtitle1'>{message}</Typography>
                </WizardStep>
            </Box>
        </Dialog>
    );
}

export default ConfirmationDialog